import React from 'react';
import OverlayWrapper from './OverlayWrapper';
import { getLabel } from '../data/labels';

export default function InfoOverlay(props) {
    const data = props.data;

    return (
        <OverlayWrapper id="xs-info-overlay">
            <div className="xs_eventInfoOverlay z-50 absolute top-0 left-0 right-0 bottom-0 grid grid-rows-[48px_1fr] bg-cs1">
                <div className="z-20 border-b border-b-cs7 bg-cs1">
                    <div className="h-full grid grid-cols-12 items-center">
                        <div className="col-start-1 col-end-3 justify-self-center inline-block" onClick={props.toggle}>
                            <i className="bi-x-lg font-medium text-lg text-cs-3"></i>
                        </div>
                        <div className="col-start-3 col-end-13 font-medium text-lg text-cs-3">{getLabel('event_info')}</div>
                    </div>
                </div>
                <div className="relative p-2 flex flex-col">
                    <div className="flex items-center">
                        <span className="font-bold text-sm text-cs10">{getLabel('event_info.country')}</span>
                        <span className="ml-1 font-medium text-sm text-cs10">{data.cname}</span>
                    </div>
                    <div className="flex items-center">
                        <span className="font-bold text-sm text-cs10">{getLabel('event_info.city')}</span>
                        <span className="ml-1 font-medium text-sm text-cs10">{data.cityname}</span>
                    </div>
                    <div className="flex items-center">
                        <span className="font-bold text-sm text-cs10">{getLabel('event_info.location')}</span>
                        <span className="ml-1 font-medium text-sm text-cs10">{data.name}</span>
                    </div>
                    <div className="flex items-center">
                        <span className="font-bold text-sm text-cs10">{getLabel('event_info.capacity')}</span>
                        <span className="ml-1 font-medium text-sm text-cs10">{data.capacity}</span>
                    </div>
                </div>
            </div>
        </OverlayWrapper>
    );
}
